import React from "react";

import _ from "lodash";
import { BriefcaseIcon } from "@heroicons/react/16/solid";

const ExperinceCard = ({ children }) => {
  return (
    <div className="p-1 px-4 border rounded-3xl flex items-center justify-between w-max text-mute-grey font-semibold text-md">
      <BriefcaseIcon className="w-4 h-4 mr-2 text-forging-yellow" />
      {_.capitalize(children)}
    </div>
  );
};

export default ExperinceCard;
